import "./Empty.css";
import { REDIRECT_URLS } from "../constants";
import { useTranslation } from "react-i18next";

const ENVIRONMENT: string = process.env.REACT_APP_ENVIRONMENT || "dev";

const getRedirectUrl = () => {
  const TST = "tst";
  const PRD = "prd";

  // ITIT
  if (process.env.REACT_APP_LOCALE === "it-it") {
    if (ENVIRONMENT === TST)
      return REDIRECT_URLS.IT.REACT_APP_TST_REDIRECT_URL || "";
    if (ENVIRONMENT === PRD)
      return REDIRECT_URLS.IT.REACT_APP_PRD_REDIRECT_URL || "";
    return REDIRECT_URLS.IT.REACT_APP_DEV_REDIRECT_URL || "";
  }

  // NLNL
  if (process.env.REACT_APP_LOCALE === "nl-nl") {
    if (ENVIRONMENT === TST)
      return REDIRECT_URLS.NL.REACT_APP_TST_REDIRECT_URL || "";
    if (ENVIRONMENT === PRD)
      return REDIRECT_URLS.NL.REACT_APP_PRD_REDIRECT_URL || "";
    return REDIRECT_URLS.NL.REACT_APP_DEV_REDIRECT_URL || "";
  }

  // DEAT
  if (process.env.REACT_APP_LOCALE === "de-at") {
    if (ENVIRONMENT === TST)
      return REDIRECT_URLS.AT.REACT_APP_TST_REDIRECT_URL || "";
    if (ENVIRONMENT === PRD)
      return REDIRECT_URLS.AT.REACT_APP_PRD_REDIRECT_URL || "";
    return REDIRECT_URLS.AT.REACT_APP_DEV_REDIRECT_URL || "";
  }

  // DECH
  if (process.env.REACT_APP_LOCALE === "de-ch") {
    if (ENVIRONMENT === TST)
      return REDIRECT_URLS.DE_CH.REACT_APP_TST_REDIRECT_URL || "";
    if (ENVIRONMENT === PRD)
      return REDIRECT_URLS.DE_CH.REACT_APP_PRD_REDIRECT_URL || "";
    return REDIRECT_URLS.DE_CH.REACT_APP_DEV_REDIRECT_URL || "";
  }

  // FRCH
  if (process.env.REACT_APP_LOCALE === "fr-ch") {
    if (ENVIRONMENT === TST)
      return REDIRECT_URLS.FR_CH.REACT_APP_TST_REDIRECT_URL || "";
    if (ENVIRONMENT === PRD)
      return REDIRECT_URLS.FR_CH.REACT_APP_PRD_REDIRECT_URL || "";
    return REDIRECT_URLS.FR_CH.REACT_APP_DEV_REDIRECT_URL || "";
  }

  // DEDE
  if (process.env.REACT_APP_LOCALE === "de-de") {
    if (ENVIRONMENT === TST)
      return REDIRECT_URLS.DE.REACT_APP_TST_REDIRECT_URL || "";
    if (ENVIRONMENT === PRD)
      return REDIRECT_URLS.DE.REACT_APP_PRD_REDIRECT_URL || "";
    return REDIRECT_URLS.DE.REACT_APP_DEV_REDIRECT_URL || "";
  }

  // ZHTW
  if (process.env.REACT_APP_LOCALE === "zh-tw") {
    if (ENVIRONMENT === TST)
      return REDIRECT_URLS.TW.REACT_APP_TST_REDIRECT_URL || "";
    if (ENVIRONMENT === PRD)
      return REDIRECT_URLS.TW.REACT_APP_PRD_REDIRECT_URL || "";
    return REDIRECT_URLS.TW.REACT_APP_DEV_REDIRECT_URL || "";
  }

  // KOKR
  if (process.env.REACT_APP_LOCALE === "ko-kr") {
    if (ENVIRONMENT === TST)
      return REDIRECT_URLS.KR.REACT_APP_TST_REDIRECT_URL || "";
    if (ENVIRONMENT === PRD)
      return REDIRECT_URLS.KR.REACT_APP_PRD_REDIRECT_URL || "";
    return REDIRECT_URLS.KR.REACT_APP_DEV_REDIRECT_URL || "";
  }

  // JAJP
  if (process.env.REACT_APP_LOCALE === "ja-jp") {
    if (ENVIRONMENT === TST)
      return REDIRECT_URLS.JP.REACT_APP_TST_REDIRECT_URL || "";
    if (ENVIRONMENT === PRD)
      return REDIRECT_URLS.JP.REACT_APP_PRD_REDIRECT_URL || "";
    return REDIRECT_URLS.JP.REACT_APP_DEV_REDIRECT_URL || "";
  }

  // ENUS
  if (ENVIRONMENT === TST)
    return REDIRECT_URLS.US.REACT_APP_TST_REDIRECT_URL || "";
  if (ENVIRONMENT === PRD)
    return REDIRECT_URLS.US.REACT_APP_PRD_REDIRECT_URL || "";
  return REDIRECT_URLS.US.REACT_APP_DEV_REDIRECT_URL || "";
};

export const Empty = () => {
  const { t } = useTranslation();

  return (
    <div className="tm">
      <div className="container">
        <div className="center-div">
          <h1>{t(`welcome to team management`)}</h1>
          <p className="p1">
            {t(
              `this is where team administrators, like business teams and territory managers, will be able to control which tools each team member has access to`,
            )}
          </p>
          <p className="p2">{t(`we'll be in touch when you get access`)}</p>
          <p className="p2">{t(`for now, head back to proshop.hillsvet`)}</p>
        </div>
      </div>
    </div>
  );
};
